import {atom} from "recoil";

export const pollSelectedAbsentDateState = atom<Date[]>({
    key: 'pollSelectedAbsentDateState',
    default: [],
})

export const pollSelectedAttendDateState = atom<Date[]>({
    key: 'pollSelectedAttendDateState',
    default: [],
})